<template>
  <div>
    <b-alert
      show
      dismissible
      v-if="
        item.situacao_rua == '1' &&
        item.rf_situacao_rua.status &&
        item.rf_situacao_rua.status == '1'
      "
    >
      <b-icon
        icon="exclamation-triangle-fill"
        variant="warning"
        animation="fade"
      ></b-icon>
      Situação de Rua está marcado com Ativo no prontuário deste Usuário/Família
    </b-alert>
    <table class="b-table table table-bordered bg-white b-table-stacked-md">
      <tbody>
        <tr>
          <td v-if="item.responsavel_familiar">
            RF:
            <strong v-if="!item.responsavel_familiar.nome_social">
              {{ item.responsavel_familiar.nome_completo }}
            </strong>
            <strong v-else>
              {{ item.responsavel_familiar.nome_social }} ( N.R.: )
              <span v-if="nome">
                {{ item.responsavel_familiar.nome_completo }}
                <a href="#" @click.prevent="nome = false"
                  ><i class="fas fa-eye-slash"></i
                ></a>
              </span>
              <span v-else>
                <a href="#" @click.prevent="nome = true"
                  ><i class="fas fa-eye"></i
                ></a>
              </span>
            </strong>
            <b-link
              :to="'/dashboard/usuario/edit/' + item.responsavel_familiar.id"
              target="_blank"
              :title="$t('Ver Prontuário do Responsável Familiar')"
              v-b-tooltip.hover
            >
              <i class="fas fa-external-link-alt"></i>
            </b-link>
            <br />
            <small class="text-muted">
              Idade: {{ item.responsavel_familiar.idade_extenso }}
            </small>
          </td>

          <td>
            <span v-if="item.codigo_familiar != null">
              Código Familiar:
              <strong>{{ item.codigo_familiar }}</strong>
            </span>
            <span v-else>
              ID Familiar:
              <strong>{{ item.id }}</strong>
            </span>

            <span class="d-block">
              <a
                href="#"
                class="font-weight-light font-italic"
                @click.prevent="showReferenciamentos"
              >
                <span v-if="showRef">
                  <i class="fas fa-unlink"></i> Fechar Referenciamentos da
                  Família
                </span>
                <span v-else>
                  <i class="fas fa-link"></i> Mostrar Referenciamentos da
                  Família
                </span>
              </a>
            </span>
          </td>
          <td>
            <span v-if="item.codigo_familiar != null">
              Família Importada:
              <strong>{{ item.cadastro }}</strong>
            </span>
            <span v-else>
              Família Cadastrada:
              <strong>{{ item.cadastrado }}</strong>
            </span>
          </td>
          <td>
            <span v-if="item.codigo_familiar != null">
              Estado Cadastral:
              <span class="small" v-html="item.estado_cadastral"></span>
            </span>
            <span v-else>
              Status:
              <span v-html="item.status_html"></span>
            </span>

            <span v-if="item.estado_cadastral_id == 4">
              <i
                class="mdi mdi-information mdi-18px text-danger"
                title="Visualizar motivo exclusão"
                style="cursor: pointer"
                @click="$emit('show-exclusao')"
              ></i>
            </span>
          </td>
        </tr>
        <tr v-if="!item.responsavel_familiar">
          <td colspan="4">
            <strong class="text-danger">FAMÍLIA SEM RESPONSÁVEL</strong>
            Insira o responsável na aba de
            <a class="text-link" @click="page = 'composicao'">
              composição familiar.
            </a>
          </td>
        </tr>
        <tr v-if="!show">
          <td colspan="4" class="text-center">
            <a
              href="#"
              class="font-weight-light font-italic"
              @click.prevent="show = true"
            >
              <i class="fas fa-plus"></i> Mais detalhes
            </a>
          </td>
        </tr>
        <tr v-if="show && item.responsavel_familiar">
          <td>
            Contato:
            <span v-if="item.codigo_familiar != null && item.contatos">
              <strong>{{ item.contatos.telefone_um }}</strong>
            </span>
            <span v-else>
              <strong>{{
                item.responsavel_familiar
                  ? item.responsavel_familiar.celular
                  : ""
              }}</strong>
            </span>
          </td>
          <td v-if="item.responsavel_familiar">
            <span>
              Data de Nascimento:
              <strong>{{
                item.responsavel_familiar.data_nascimento | formatDate
              }}</strong>
            </span>
          </td>
          <td v-if="item.responsavel_familiar">
            CPF:
            <strong>{{
              item.responsavel_familiar.documento
                ? item.responsavel_familiar.documento.cpf
                : ""
            }}</strong>

            <b-link
              href="#"
              v-if="item.responsavel_familiar.documento.cpf == null"
              v-b-tooltip.hover
              title="Não sabe o número do CPF ou não foi inserido no cadastro!"
            >
              <b-icon
                icon="exclamation-triangle-fill"
                variant="warning"
                animation="fade"
              ></b-icon>
            </b-link>
          </td>
          <td v-if="item.responsavel_familiar">
            NIS:
            <strong>{{
              item.responsavel_familiar.documento
                ? item.responsavel_familiar.documento.nis
                : ""
            }}</strong>

            <b-link
              href="#"
              v-if="item.responsavel_familiar.documento.nis == null"
              v-b-tooltip.hover
              title="Não sabe o número do NIS ou não foi inserido no cadastro!"
            >
              <b-icon
                icon="exclamation-triangle-fill"
                variant="warning"
                animation="fade"
              ></b-icon>
            </b-link>
          </td>
        </tr>
        <tr v-if="show">
          <td colspan="2">
            <span v-if="item.codigo_familiar != null">
              Data de Alteração Neste Cadastro:
              <strong>{{ item.data_atualizacao }}</strong>
              <br />
              Data da Entrevista:
              <strong>{{ item.data_entrevista }}</strong>
            </span>
            <span v-else>
              Última atualização no sistema:
              <strong>{{ item.atualizacao }}</strong>
              <span v-if="item.update_user">
                por <strong>{{ item.update_user }}</strong>
              </span>
            </span>
          </td>
          <td colspan="2">
            <span v-if="item.codigo_familiar != null">
              Técnico do CadÚnico:
              <strong>{{ item.nome_entrevistador }}</strong>
            </span>
            <span v-else-if="item.user">
              Técnico que realizou o cadastro:
              <strong>{{ item.user.name }} - {{ item.unidade.nome }}</strong>
            </span>
          </td>
        </tr>
        <tr v-if="show">
          <td colspan="2">
            Data de atualização da família pelo município:
            <strong>{{ item.data_atualizacao_gestao_municipal || "Não informado" }}</strong>
          </td>
          <td colspan="2">
            Data de atualização da família pelo cidadão:
            <strong>{{ item.data_atualizacao_cidadao || "Não informado" }}</strong>
          </td>
        </tr>
        <tr v-if="show">
          <td colspan="4">
            Data de atualização da família por Integração de Dados:
            <strong>{{ item.data_atualizacao_integracao || "Não informado" }}</strong>
          </td>
        </tr>
        <tr v-if="show">
          <td colspan="4" class="text-center">
            <a
              href="#"
              class="font-weight-light font-italic"
              @click.prevent="show = false"
            >
              <i class="fas fa-times"></i> Fechar mais detalhes
            </a>
          </td>
        </tr>
        <tr v-if="showRef">
          <td colspan="4">
            <div class="row">
              <load v-if="loading_referenciamento" mode="table" />
              <div v-else class="col-md-12 mb-2">
                <table class="table">
                  <tr
                    v-for="(ref, index) in item.referenciamentos"
                    :key="ref.id"
                  >
                    <td>{{ ref.unidade }}</td>
                    <td>{{ ref.cadastro }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-md p-0 m-0"
                        @click="removeReferenciamento(ref.id, index)"
                      >
                        <i class="fa fa-trash text-danger"></i>
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <form @submit.prevent="submitReferenciamento" ref="addItem">
              <div class="row">
                <form-select
                  v-model="referenciamentos"
                  label="Adicionar Unidade"
                  :itens="listunidades"
                  :disabled="desabledSearchUnidade"
                  :loading="loadingSearchUnidade"
                  :required="true"
                />
              </div>
              <div class="row pt-4 px-0 d-flex justify-content-end">
                <a
                  href="#"
                  class="router-link-exact-active active"
                  @click="getReferenciamentos"
                >
                  <i class="fas fa-history"></i> Histórico de referenciamentos
                </a>

                <div class="col-auto px-2 text-right">
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                  </button>
                </div>
              </div>
            </form>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="mt-3 d-flex justify-content-end"
      v-if="item && item.id && item.responsavel_familiar"
    >
      <button
        type="button"
        class="btn btn-sm btn-outline-primary"
        @click="toggleHistoricoCadastral"
      >
        <i
          class="mdi mdi-18px"
          :class="
            mostrarHistoricoCadastral ? 'mdi-eye-off-outline' : 'mdi-history'
          "
        />
        {{
          mostrarHistoricoCadastral
            ? "Ocultar histórico cadastral"
            : "Exibir histórico cadastral"
        }}
      </button>
    </div>
    <div
      class="mt-3"
      v-if="
        historicoJaRenderizado && item && item.id && item.responsavel_familiar
      "
      v-show="mostrarHistoricoCadastral"
    >
      <HistoricoEstadoCadastral
        ref="historicoEstadoCadastral"
        :family-id="item.id"
        :embedded="true"
      />
    </div>
    <b-modal
      id="getReferenciamentosModal"
      centered
      hide-footer
      size="lg"
      title="Histórico de Referenciamentos"
    >
      <load mode="table" v-if="loadingRef" message="Carregando Histórico" />
      <div v-else class="col-12">
        <b-table
          :fields="[
            {
              key: 'new_values',
              label: $t('Unidades'),
            },
            {
              key: 'user_id',
              label: $t('Técnico'),
            },
            {
              key: 'created_at',
              label: $t('Data'),
            },
          ]"
          :items="listReferenciamentos"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="xs"
          table-class="mb-3"
        >
          <template v-slot:cell(new_values)="data">
            <span
              v-for="(unidade, index) in data.item.new_values"
              :key="unidade.id"
            >
              <ul>
                <li v-for="u in unidade" :key="u.id">
                  <small> {{ u.nome }}</small>
                </li>
              </ul>
            </span>
          </template>

          <template v-slot:cell(user)="data">
            {{ data.item.user_id }}
          </template>
          <template v-slot:cell(created_at)="data">
            {{ data.item.created_at }}
          </template>

          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">
                {{ $t("No records found") }}
              </h3>
            </div>
          </template>
        </b-table>
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getReferenciamentos"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import HistoricoEstadoCadastral from "../../../../../Modules/Familia/Resources/assets/js/includes/HistoricoEstadoCadastral.vue";

export default {
  name: "HeaderFamilia",
  props: ["item"],
  components: {
    HistoricoEstadoCadastral,
  },
  data() {
    return {
      nome: false,
      show: false,
      showRef: false,
      loadingRef: false,
      referenciamentos: [],
      unidadesReferenciamentos: [],
      familiaReferenciamento: null,
      unidades: [],
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loading_referenciamento: false,
      listReferenciamentos: [],
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      perPage: 10,
      page: 1,
      mostrarHistoricoCadastral: false,
      historicoJaRenderizado: false,
    };
  },
  watch: {
    show: function (value) {
      value ? true : false;
    },
    referenciamentos: function (value) {
      this.unidadesReferenciamentos = value;
    },
  },
  mounted() {
    this.getUnidades();
    this.referenciamentos = this.item.referenciamentos;
    this.familiaReferenciamento = this.item.id;
  },
  computed: {
    listunidades() {
      if (this.item.referenciamentos) {
        //Criar um array com os ids das unidades referenciadas
        let referenciamento_temp = this.item.referenciamentos.map((e) => e.id);
        //Criar um array com os tipos das unidades referenciadas
        let unidades_tipo = this.item.referenciamentos.map((e) => e.tipo_id);

        return this.unidades.filter((unidade) => {
          let result = referenciamento_temp.includes(unidade.id);
          let result_tipos = unidades_tipo.includes(unidade.tipo_id);

          //Faz uma verificação para saber se já existe alguma unidade referenciada do mesmo tipo
          if (result_tipos) {
            return false;
          }
          /*Se não existir unidades referenciadas do mesmo tipo ou se ainda não foi referenciada o retorno deverá ser true
           * porem, como é verificado se já existe com o metodo include e ele retorna true, é necessário usar o !result para informar que
           * essa unidade não deverá ser retornada no filter
           */
          return !result;
        });
      } else {
        return this.unidades;
      }
    },
  },
  methods: {
    refreshHistoricoEstadoCadastral() {
      if (
        this.$refs.historicoEstadoCadastral &&
        this.$refs.historicoEstadoCadastral.forceReload
      ) {
        this.$refs.historicoEstadoCadastral.forceReload();
      }
    },
    showReferenciamentos() {
      this.showRef = !this.showRef;
    },
    toggleHistoricoCadastral() {
      this.mostrarHistoricoCadastral = !this.mostrarHistoricoCadastral;

      if (this.mostrarHistoricoCadastral && !this.historicoJaRenderizado) {
        this.historicoJaRenderizado = true;

        this.$nextTick(() => {
          if (
            this.$refs.historicoEstadoCadastral &&
            this.$refs.historicoEstadoCadastral.forceReload
          ) {
            this.$refs.historicoEstadoCadastral.forceReload();
          }
        });
      }
    },
    submitReferenciamento() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      var dados = {
        familia: this.familiaReferenciamento,
        unidades: this.unidadesReferenciamentos,
      };
      axios
        .post(`api/dashboard/familias/unidades/sync`, dados)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: "Referenciamento realizado!",
          });
          this.$emit("update");
        })
        .finally(() => {
          ladda.stop();
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getReferenciamentos();
      }
    },
    getReferenciamentos() {
      this.$bvModal.show("getReferenciamentosModal");
      this.loadingRef = true;
      axios
        .get(
          `api/dashboard/familias/referenciamentos/${this.$route.params.id}`,
          {
            params: {
              page: this.page,
              perPage: this.perPage,
            },
          }
        )
        .then((response) => {
          this.listReferenciamentos = response.data.data;

          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getReferenciamentos();
          } else {
            this.loadingRef = false;
          }
        })
        .finally(() => {
          this.loadingRef = false;
        });
    },
    removeReferenciamento(unidade_id, index) {
      this.loading_referenciamento = true;
      axios
        .post(`api/dashboard/familias/unidades/remove`, {
          unidade_id: unidade_id,
          familia_id: this.item.id,
        })
        .then((response) => {
          this.$snack.success({
            button: false,
            text: "Referenciamento atualizado!",
          });
          this.item.referenciamentos.splice(index, 1);
          // this.$bvModal.hide("referenciarFamilia");
        })
        .finally(() => {
          this.loading_referenciamento = false;
        });
    },
  },
};
</script>
